/**
 * AdminPageShell
 * Unified page container for all admin views.
 * Provides consistent padding, max-width, background and spacing.
 */

import { cn } from '@/lib/utils';

interface AdminPageShellProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  fullWidth?: boolean;
}

export function AdminPageShell({
  children,
  className,
  noPadding = false,
  fullWidth = false,
}: AdminPageShellProps) {
  return (
    <div
      className={cn(
        'flex-1 overflow-y-auto',
        !noPadding && 'px-4 py-4 sm:p-6',
        className
      )}
    >
      <div className={cn(!fullWidth && 'container mx-auto max-w-7xl')}>
        {children}
      </div>
    </div>
  );
}
